import { Inject, Options, Vue } from "vue-property-decorator";
import AppointCoordinator from "../appoint-coordinator/index.vue";
import { ComplianceForm, FormStatus, PartBFormStatus } from "@/shared/modules/typescript-trustapi-client/models";
import AssignTrustContact from "../assign-trustcontact/index.vue";
import { AuthorizedUser } from "@/trust-atcs-app/models/authorized-user";
import store from "@/trust-atcs-app/store";
import { RouteN } from "@/trust-atcs-app/constants/router-name";
import { Section } from "../swipe-stepper/nav-step";
import AppointAndTerminateEE from "../appoint-terminate-ee-request/index.vue";
import { TrustAPI } from "@/shared/modules/trust-api";
import AccessDenied from "../access-denied-modal/index.vue";
import LoadingSpinner from "@/shared/components/loading-spinner/index.vue";
import { EventEmitter } from "events";
import ActionModal from "../action-modal/index.vue";
import Popover from "@/shared/components/popover/index.vue";
import FormatDateTimeMixin from '@/shared/mixins/format-datetime';
import { AppInsights } from "@/trust-atcs-app/appInsights";
import LoggedInElsewhere from "../loggedin-elsewhere-modal/index.vue";


@Options({
  props: {
    dashboardType: Number,
    practice: <ComplianceForm>{},
  },
  components: {
    AppointCoordinator,
    AssignTrustContact,
    AppointAndTerminateEE,
    AccessDenied,
    LoggedInElsewhere,
    LoadingSpinner,
    ActionModal,
    Popover,
  },
  mixins: [FormatDateTimeMixin],
})
export default class PracticeCard extends Vue {

  @Inject({ from: 'apiService', default: new TrustAPI() })
  private apiService!: TrustAPI;

  private ai = new AppInsights;

  private dashboardType!: number;
  private practice!: ComplianceForm;
  private editingTrustCoordinator = false;
  private editingTrustContact = false;
  private editingEE = false;

  private checkingFormStatus = false;
  private formStatus: FormStatus = null as any;
  private showAccessDeniedModal = false;
  private isSignatoriesStatus = false;
  private accessDeniedModalTypeA = false;
  private showLoggedInElsewhereModal = false;
  private enableConcurrencyValidation = false;

  private currentWIPFormType = '';
  private currntWIPComplianceForm: ComplianceForm = null as any;

  private typeA = false;
  private typeB = false;
  private typeC = false;

  private statusColorCSS(statusId: number) {
    switch (statusId) {
      case 1:
        // In progress
        return "color: #D7B301";
      case 2:
      case 15:
        // Part A Resubmission required
        // EE: Part A Resubmission required
        return "color: #638886";
      case 3:
      case 12:
        // Part B Resubmission required
        return "color: #638886";
      case 4:
        // Not yet started
        return "color: #9EA5AB";
      case 5:
      case 11:
        // Awaiting External Examiner response
        // EE: Ready to be reviewed
        return "color: #1968AB";
      case 6:
      case 13:
        // Non-compliant
        // EE: Trust Compliance not received
        return "color: #C0392B";
      case 7:
      case 14:
        // Completed
        return "color: #27AE60";
    }
  }

  private getCardFooterText(practice: any) {
    let rtText = '';
    if (!practice) {
      return rtText;
    }
    const isPrincipal = practice.isPrincipal ? 'Principal' : '';
    let isTrustCoordinator = practice.isTrustCoordinator ? 'Trust Coordinator' : '';
    isTrustCoordinator = practice.isPrincipal && practice.isTrustCoordinator ? ' / ' + isTrustCoordinator : isTrustCoordinator;
    let isTrustContact = practice.isTrustContact ? 'Authorised Trust Contact' : '';
    isTrustContact = (practice.isPrincipal || practice.isTrustCoordinator) && practice.isAuthorisedTrustContact ? ' / ' + isTrustContact : isTrustContact;
    if (isPrincipal || isTrustCoordinator || isTrustContact) {
      rtText = 'You are this Practice\'s ' + isPrincipal + isTrustCoordinator + isTrustContact + '.';
    }

    return rtText;
  }

  get userAccount(): AuthorizedUser {
    return store.getters.getUserAccount;
  }

  private getPracticeNameDisplay(practice: ComplianceForm): string {
    const firmId = practice.practice?.firmId ? ' (' + practice.practice?.firmId + ')' : '';
    return this.practice.practice?.practiceName + firmId;
  }

  private closeAccessDeniedModal(): void {
    this.showAccessDeniedModal = false;
    this.formStatus = null as any;
  }

  private closeLoggedInElsewhereModal(): void {
    this.showLoggedInElsewhereModal = false;
    this.formStatus = null as any;
  }

  private async proceedToOvertakeSession(isSignatoriesStatus: any = false): Promise<void> {
    let resp: any = null;
    let resp1: any = null;
    const p = this.currntWIPComplianceForm;

    try {
      switch (this.currentWIPFormType) {
        case 'partA': // Part A
          resp = await this.apiService.PartAFormApi?.apiV2PartAFormKickOutFormStatusComplianceFormIdGet(p.id);
          resp1 = await this.apiService.PartAFormApi?.apiV2PartAFormGetFormStatusComplianceFormIdGet(p.id);
          break;
        case 'partB':
          if (isSignatoriesStatus) {
            resp = await this.apiService.PeopleAtcsApi?.apiV2AtcsPeopleReleaseManageSignatoryLockPost(p.id);
          } else {
            resp = await this.apiService.PartBFormApi?.apiV2PartBFormKickOutFormStatusComplianceFormIdGet(p.id);
          }
          resp1 = await this.apiService.PartBFormApi?.apiV2PartBFormGetFormStatusComplianceFormIdGet(p.id);
          break;
        case 'eer':
          resp = await this.apiService.EeReportApi?.apiV2EeReportKickOutFormStatusComplianceFormIdGet(p.id);
          resp1 = await this.apiService.EeReportApi?.apiV2EeReportGetFormStatusComplianceFormIdGet(p.id);
          break;
        default:
      }

      this.formStatus = resp1.data.data as FormStatus;

      switch (this.currentWIPFormType) {
        case 'partA': // Part A
          store.dispatch('setSelectedComplianceFormA', p);
          this.$router.push({ name: RouteN.ATCS.FormPartA.n, query: { id: p.id, sec: Section.overview } });
          break;
        case 'partB':// Part B
          store.dispatch('setSelectedComplianceFormB', p);
          this.$router.push({ name: RouteN.ATCS.FormPartB.n, query: { id: p.id, sec: Section.overview } });
          break;
        case 'eer':
          store.dispatch('setSelectedComplianceFormEER', p);
          this.$router.push({ name: RouteN.ATCS.FormEer.n, query: { id: p.id, sec: Section.overview } });
          break;
        default:
      }

      this.showLoggedInElsewhereModal = false;

    } catch (err: any) {
      this.ai.trackException('Error kicking out existing session: ' + err);
      this.eventCtrl.emit('show-snackbar', 'error', 'Error kicking out existing session: ' + err);
    }
  }

  private clickPartA(p: ComplianceForm): void {
    if (this.practice?.partAViewEnable) {
      this.viewPartA(p);
    } else if (this.practice?.partAAnswerEnable) {
      this.answerPartA(p);
    } else {
      this.ai.trackException('Unexpected PartA status');
      this.eventCtrl.emit('show-snackbar', 'error', 'Unexpected error');
    }
  }

  private async viewPartA(p: ComplianceForm): Promise<void> {
    try {
      const resp: any = await this.apiService.FileAtcsApi?.apiV2FileAtcsGetPartAFilePartAIdGet(p.partA.id);
      const base64Data = resp.data.data.base64AsString;
      const base64Response = await fetch(`data:application/pdf;base64,${base64Data}`);
      const blob = await base64Response.blob();
      const documentURL = window.URL.createObjectURL(blob);
      window.open(documentURL, 'blank');
      setTimeout(() => {
        URL.revokeObjectURL(documentURL);
      }, 300000);
      Promise.resolve(0);
    } catch (err: any) {
      this.ai.trackException('Error downloading View PartA PDF: ' + err);
      if (err.response.status === 400 && err.response.data?.errorCode == 10001) {
        // handle resubmit request in app.ts
      } else {
        this.eventCtrl.emit('show-snackbar', 'error', 'Error downloading View Part A PDF');
        Promise.reject(0);
      }
    }
  }


  private async answerPartA(p: ComplianceForm): Promise<void> {
    try {
      this.checkingFormStatus = true;
      const resp: any = await this.apiService.PartAFormApi?.apiV2PartAFormGetFormStatusComplianceFormIdGet(p.id);
      this.formStatus = resp.data.data as FormStatus;

      if (this.formStatus == null) {
        this.eventCtrl.emit('show-snackbar', 'error', 'Error checking form status - null data');
      } else if (this.formStatus?.isUpdating && this.formStatus?.updatingBy?.lawId != this.userAccount?.user?.originalLawId) {
        this.showAccessDeniedModal = true;
      } else if (this.formStatus?.isUpdating && this.formStatus?.updatingBy?.lawId == this.userAccount?.user?.originalLawId) {
        // if (this.formUpdatingKey) {
        //   this.closeSessionAndRedirect(p, 'partA');
        // } else {
        //   this.showAccessDeniedModal = true;
        // }
        this.currentWIPFormType = 'partA';
        this.currntWIPComplianceForm = p;
        this.showLoggedInElsewhereModal = true;
      } else {
        this.showAccessDeniedModal = false;
        store.dispatch('setSelectedComplianceFormA', p);
        this.$router.push({ name: RouteN.ATCS.FormPartA.n, query: { id: p.id, sec: Section.overview } });
      }
    } catch (err) {
      this.ai.trackException('Error checking Part A status: ' + err);
      this.eventCtrl.emit('show-snackbar', 'error', 'Error checking Part A status: ' + err);
    } finally {
      this.checkingFormStatus = false;
    }
  }


  private clickPartB(p: ComplianceForm): void {
    if (this.practice?.partBViewEnable) {
      this.viewPartB(p);
    } else if (this.practice?.partBAnswerEnable) {
      this.answerPartB(p);
    } else {
      this.ai.trackException('Unexpected Part B');
      this.eventCtrl.emit('show-snackbar', 'error', 'Unexpected error');
    }
  }

  private async viewPartB(p: ComplianceForm): Promise<void> {
    try {
      const resp: any = await this.apiService.FileAtcsApi?.apiV2FileAtcsGetPartBFilePartBIdGet(p.partB.id);
      const base64Data = resp.data.data.base64AsString;
      const base64Response = await fetch(`data:application/pdf;base64,${base64Data}`);
      const blob = await base64Response.blob();
      const documentURL = window.URL.createObjectURL(blob);
      window.open(documentURL, 'blank');
      setTimeout(() => {
        URL.revokeObjectURL(documentURL);
      }, 300000);
      Promise.resolve(0);
    } catch (err: any) {
      this.ai.trackException('Error downloading View PartB PDF: ' + err);
      if (err.response.status === 400 && err.response.data?.errorCode == 10001) {
        // handle resubmit request in app.ts
      } else {
        this.eventCtrl.emit('show-snackbar', 'error', 'Error downloading View Part B PDF');
        Promise.reject(0);
      }
    }
  }

  private async answerPartB(p: ComplianceForm) {
    try {
      this.checkingFormStatus = true;
      this.isSignatoriesStatus = false;
      this.typeA = false;
      this.typeB = false;
      this.typeC = false;
      const resp: any = await this.apiService.PartBFormApi?.apiV2PartBFormGetFormStatusComplianceFormIdGet(p.id);
      this.formStatus = resp.data.data as FormStatus;

      const dataResp: PartBFormStatus = resp.data.data as PartBFormStatus;
      const signatoriesIsUpdating: boolean = dataResp.manageAuthorizedSignatoryPageStatus?.isUpdating;

      if (this.formStatus == null) {
        this.eventCtrl.emit('show-snackbar', 'error', 'Error checking form status - null data');
      } else if (this.formStatus?.isUpdating && this.formStatus?.updatingBy?.lawId != this.userAccount?.user?.originalLawId) {

        this.showAccessDeniedModal = true;

      } else if (this.formStatus?.isUpdating && this.formStatus?.updatingBy?.lawId == this.userAccount?.user?.originalLawId) {

        this.currentWIPFormType = 'partB';
        this.currntWIPComplianceForm = p;
        this.showLoggedInElsewhereModal = true;

      } else if(signatoriesIsUpdating && dataResp?.manageAuthorizedSignatoryPageStatus?.updatingBy?.lawId != this.userAccount?.user?.originalLawId) {

        this.showAccessDeniedModal = true;
        this.isSignatoriesStatus = true;
        this.typeB = true;

      } else if (signatoriesIsUpdating && dataResp?.manageAuthorizedSignatoryPageStatus?.updatingBy?.lawId == this.userAccount?.user?.originalLawId) {

        this.showAccessDeniedModal = true;
        this.isSignatoriesStatus = true;
        this.typeB = true;

      }else {
        this.showAccessDeniedModal = false;
        this.isSignatoriesStatus = false;
        store.dispatch('setSelectedComplianceFormB', p);
        this.$router.push({ name: RouteN.ATCS.FormPartB.n, query: { id: p.id, sec: Section.overview } });
      }
    } catch (err) {
      this.isSignatoriesStatus = false;
      this.ai.trackException('Error checking PartB status: ' + err);
      this.eventCtrl.emit('show-snackbar', 'error', 'Error checking PartB status: ' + err);
    } finally {
      this.checkingFormStatus = false;
    }

  }

  private async closeSessionAndRedirect(p: ComplianceForm, formType: string): Promise<void> {
    let apiFunction: any;
    let routeName: string;

    switch (formType) {
      case 'partA':
        apiFunction = this.apiService.PartAFormApi?.apiV2PartAFormClosePost.bind(this.apiService.PartAFormApi);
        store.dispatch('setSelectedComplianceFormA', p);
        routeName = RouteN.ATCS.FormPartA.n;
        break;
      case 'partB':
        apiFunction = this.apiService.PartBFormApi?.apiV2PartBFormClosePost.bind(this.apiService.PartBFormApi);
        store.dispatch('setSelectedComplianceFormB', p);
        routeName = RouteN.ATCS.FormPartB.n;
        break;
      case 'eer':
        apiFunction = this.apiService.EeReportApi?.apiV2EeReportClosePost.bind(this.apiService.EeReportApi);
        store.dispatch('setSelectedComplianceFormEER', p);
        routeName = RouteN.ATCS.FormEer.n;
        break;
      default:
        throw new Error('Invalid formType');
    }

    if (!apiFunction) {
      throw new Error('API function is not defined.');
    }

    try {
      await apiFunction?.({
        complianceFormId: p.id,
        updatingKey: this.formUpdatingKey ?? null
      });
      this.$router.push({ name: routeName, query: { id: p.id, sec: Section.overview } });
    } catch (err) {
      this.eventCtrl.emit('show-snackbar', 'error', 'Error closing existing session: ' + err);
      this.ai.trackException('Error closing existing session: ' + err);
    }

  }

  get formUpdatingKey(): string {
    return store.getters.getFormUpdatingKey;
  }

  private clickEer(p: ComplianceForm): void {
    if (this.practice?.eeReport?.complianceFormStatus?.name == 'Submitted') {
      this.viewEer(p);
    } else if (this.practice?.partAViewEnable && this.practice?.partBViewEnable) {
      this.answerEer(p);
    } else {
      this.eventCtrl.emit('show-snackbar', 'error', 'Unexpected error');
    }
  }

  async viewEer(p: ComplianceForm): Promise<void> {
    try {
      const resp: any = await this.apiService.FileAtcsApi?.apiV2FileAtcsGetEeReportFileEeReportIdGet(p.eeReport.id);
      const base64Data = resp.data.data.base64AsString;
      const base64Response = await fetch(`data:application/pdf;base64,${base64Data}`);
      const blob = await base64Response.blob();
      const documentURL = window.URL.createObjectURL(blob);
      window.open(documentURL, 'blank');
      setTimeout(() => {
        URL.revokeObjectURL(documentURL);
      }, 300000);
      Promise.resolve(0);
    } catch (err: any) {
      this.ai.trackException('Error downloading View EE report PDF: ' + err);
      if (err.response.status === 400 && err.response.data?.errorCode == 10001) {
        // handle resubmit request in app.ts
      } else {
        this.eventCtrl.emit('show-snackbar', 'error', 'Error downloading View EE report PDF');
        Promise.reject(0);
      }
    }
  }

  private async answerEer(p: ComplianceForm) {
    try {
      this.checkingFormStatus = true;
      const resp: any = await this.apiService.EeReportApi?.apiV2EeReportGetFormStatusComplianceFormIdGet(p.id);
      this.formStatus = resp.data.data as FormStatus;

      if (this.formStatus == null) {
        this.eventCtrl.emit('show-snackbar', 'error', 'Error checking form status - null data');
      } else if (this.formStatus?.isUpdating && this.formStatus?.updatingBy?.lawId != this.userAccount?.user?.originalLawId) {
        this.showAccessDeniedModal = true;
      } else if (this.formStatus?.isUpdating && this.formStatus?.updatingBy?.lawId == this.userAccount?.user?.originalLawId) {
        // if (this.formUpdatingKey) {
        //   this.closeSessionAndRedirect(p, 'eer');
        // } else {
        //   this.showAccessDeniedModal = true;
        // }
        this.currentWIPFormType = 'eer';
        this.currntWIPComplianceForm = p;
        this.showLoggedInElsewhereModal = true;
      } else {
        this.showAccessDeniedModal = false;
        store.dispatch('setSelectedComplianceFormEER', p);
        this.$router.push({ name: RouteN.ATCS.FormEer.n, query: { id: p.id, sec: Section.overview } });
      }
    } catch (err: any) {
      this.ai.trackException('Error checking form EER status: ' + err);
      if (err.response.status === 400 && err.response.data?.errorCode == 10001) {
        // handle resubmit request in app.ts
      } else {
        this.eventCtrl.emit('show-snackbar', 'error', 'Error checking form status' + err);
      }
    } finally {
      this.checkingFormStatus = false;
    }
  }

  get eventCtrl(): EventEmitter {
    return store.getters.getEventController;
  }

  private showActionModal = false;
  private actionType = '';

  private clickResubmit(): void {
    this.actionType = 'resubmit-part-b';
    this.showActionModal = true;
  }

  private reloadData(): void {
    this.eventCtrl.emit('loadCardData');
  }

  private isNotRequired(text: string): boolean {
    // return substring of text is 'not required';
    return text?.includes('not required');
  }

  get signatoriesPracticeCoreId(): number | null {
    return store.getters.getSelectedPracticeCoreId;
  }

  get signatoriesUpdatingKey(): string {
    return store.getters.getSignatoriesUpdatingKey;
  }

}

